import type { Content } from "@prismicio/client";
import type { QuestGroup, QuestOrder } from "@ui-kit/QuestList";
import localforage from "localforage";
import { useEffect, useRef, useState } from "react";
import { createQuestOrder } from "./transform/createQuestOrder";

export { createQuestOrder } from "./transform/createQuestOrder";

export const useOrderingQuest = (
  walletAddress: string | undefined,
  game: Content.GameDocument,
  questGroups: QuestGroup[],
) => {
  const [questOrder, setQuestOrder] = useState<QuestOrder>([]);

  const storageKey = `${game.uid}_quest_order_${walletAddress}`;

  // Ref to ensure the retrieval runs only once after walletAddress is available.
  const hasRetrievedRef = useRef(false);

  useEffect(() => {
    const retrieveQuestOrder = async () => {
      // Ensure the wallet address and rawQuestData are available before proceeding
      if (!walletAddress) return;
      if (!questGroups || questGroups.length === 0) return;
      if (hasRetrievedRef.current) return;

      // Try to retrieve the stored data from storage
      const storedData: QuestOrder | null =
        await localforage.getItem(storageKey);
      if (storedData) {
        setQuestOrder(storedData);
        hasRetrievedRef.current = true;
        return;
      }

      // Create Quest ordering based on the raw quest data
      const data = createQuestOrder(questGroups);
      setQuestOrder(data);

      // Save the transformed data to localForage
      try {
        await localforage.setItem(storageKey, data);
        console.log("Quest order saved to localForage");
      } catch (error) {
        console.error("Error saving Quest order:", error);
      }

      hasRetrievedRef.current = true;
    };

    retrieveQuestOrder();
  }, [walletAddress, questGroups, storageKey]);

  return questOrder;
};
